import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const CharityLegacySettingsSection = function CharityLegacySettingsSection({
    header, body, action,
}) {
    return (
        <section className={styles.section}>
            <div className={`layout-grouping layout-pinned ${styles.container}`}>
                <div>
                    <h2>{header}</h2>
                    <div>{body}</div>
                </div>
                <div>
                    {action}
                </div>
            </div>
        </section>
    );
};

CharityLegacySettingsSection.propTypes = {
    header: PropTypes.node.isRequired,
    body: PropTypes.node.isRequired,
    action: PropTypes.node.isRequired,
};

CharityLegacySettingsSection.defaultProps = {
};

export default CharityLegacySettingsSection;
